import { useState } from "react";
import { useGetItems } from 'Features/HTTP/RequestHandlers';
import { useResponseHandler, useErrorHandler } from 'Features/HTTP/ResponseHandler';
import { useTranslation } from 'react-i18next';
import apiConfig from 'Application/configurations/apiConfig';
import IListSurveyType from "./IListSurveyType";
import { useAccessTokens } from 'Features/Authentication';

function useGetSurveyTypes () {

    const { t } = useTranslation();
    const [ surveyTypes, setSurveyTypes ] = useState<IListSurveyType[]>([]);
    const getItems = useGetItems();
    const responseHandler = useResponseHandler();
    const errorHandler = useErrorHandler();
    const getToken = useAccessTokens();
    const AccessAsUser = apiConfig.scopes.AccessAsUser;
    

   /** List all survey types
     * @returns {Array<IListSurveyType>} survey types */
    const listSurveyTypes = async () => {

        const basePath = apiConfig.basePath;
        const endpoint = apiConfig.endpoints.surveytypes;
        const url = new URL(`${basePath}/${endpoint}`);
        const accessToken = await getToken([AccessAsUser]);

        const options = {
            accessToken: accessToken
        }
        
        try {

            const response = await getItems(url, options);
            const data = response?.data || [];
            setSurveyTypes(data);
            return responseHandler(response, "useGetSurveyTypes", { operation: "list", hide: true });

        } catch (error: any) {

            let problemTitle = error && error.data && error.data.title ? error.data.title : "";
            let body = null;

            if (problemTitle === "General.RequestorNotExist") body = t('features.surveyType.requestorNotExist');
            if (problemTitle === "SurveyType.ListPermissionDenied") body = t('features.surveyType.listPermissionDenied');

            return errorHandler(error, "useGetSurveyTypes", { operation: "list", hide: false, messageBody: body });
   
        }

    }

    return { surveyTypes, setSurveyTypes, listSurveyTypes };

}

export default useGetSurveyTypes;